module.exports = __webpack_public_path__ + "static/img/1.f786ffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgzgk/1.png
// module id = Wwmp
// module chunks = 0